import ScrollAnimation from 'react-animate-on-scroll';
import "./headline.css";

export default function Headline() {
  return (
    <ScrollAnimation animateIn="fadeIn"animateOnce= {true}>
      <div className="ae-headline-wrapper ae-page-container">
        <h2 className="h1 ae-green-text">ActEd.</h2>
        <div className="ae-headline-text-wrapper">
          <p>
            At ActEd. we specialise in
            developing presence through vocal, body language and communication
            coaching. <br/>We are trained actors and educational specialists with
            experience of mentoring, coaching, and training ECTs, teachers and
            professionals in a variety of settings.
          </p>
        </div>
      </div>
    </ScrollAnimation>
  );
}
